var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonIconTestDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.601,
    height: 66.894,
    viewBox: "0 0 68.601 66.894",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ButtonIcon_test_disabled",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_608",
    "data-name": "Raggruppa 608",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_983",
    "data-name": "Tracciato 983",
    d: "M19.19,0,.666,16.879,0,41.729,9.351,61.408l23.775,5.486,23.13-10.3L68.6,33.472,58.469,5.173,31.125.154Z",
    fill: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_609",
    "data-name": "Raggruppa 609"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_984",
    "data-name": "Tracciato 984",
    d: "M48.233,43.154,40.028,28.8l-.57-.391L39.33,18l.6-.156-.026-.294L40,17l-.07-.929.148-1.367-9.831-.111-4.583.267.964,1.1.977,1.564.485.538-.1,10.143-.094.97L19.672,43.091l1.322,1.4,4.964.624,7.7.007,2.356-.155,5.826-.022,3.767.1ZM27.5,34.918l1.261-1.527,1.6-3.4.2-1.147.463-10.792.182-.537,5.142.113.519.412L36.4,28.689l.573,1.608,2.116,2.832,1.078,1.884Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_655",
    "data-name": "Raggruppa 655"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_984-2",
    "data-name": "Tracciato 984",
    d: "M48.233,43.154,40.028,28.8l-.57-.391L39.33,18l.6-.156-.026-.294L40,17l-.07-.929.148-1.367-9.831-.111-4.583.267.964,1.1.977,1.564.485.538-.1,10.143-.094.97L19.672,43.091l1.322,1.4,4.964.624,7.7.007,2.356-.155,5.826-.022,3.767.1ZM27.5,34.918l1.261-1.527,1.6-3.4.2-1.147.463-10.792.182-.537,5.142.113.519.412L36.4,28.689l.573,1.608,2.116,2.832,1.078,1.884Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_985",
    "data-name": "Tracciato 985",
    d: "M10.373,15.108l5.275-5.275L54.921,48.77l-5.275,5.275Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1066",
    "data-name": "Tracciato 1066",
    d: "M10.69,14.279l4.121-4.121L54.6,49.6,50.482,53.72Z",
    fill: "rgba(0,0,0,0)",
    stroke: "#9a9a9a",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconTestDisabled);
export default __webpack_public_path__ + "static/media/ButtonIcon_test_disabled.2703a1edc2a95e7a7f19732f23a5b297.svg";
export { ForwardRef as ReactComponent };